import { Component, OnInit, inject, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import {
  InitialStateService,
  LocalStorageService,
  CallOutSize,
  CallOutComponent,
  CallOutHeaderComponent,
  HrefDirective,
  IconComponent
} from '@tdwb/core';

@Component({
  selector: 'td-wb-dashboard-as-start-page-callout',
  templateUrl: './dashboard-as-start-page-callout.component.html',
  styleUrls: ['./dashboard-as-start-page-callout.component.scss'],
  imports: [
    TranslateDirective,
    CallOutComponent,
    CallOutHeaderComponent,
    HrefDirective,
    IconComponent
  ]
})
export class DashboardAsStartPageCalloutComponent implements OnInit {
  private readonly localStorageService = inject(LocalStorageService);
  private readonly initialStateService = inject(InitialStateService);

  private static readonly LTI_DASHBOARD_AS_START_PAGE_CALLOUT: string = 'ltiDashboardAsStartPageCallout';

  readonly layout = input<string | undefined>(undefined);
  readonly size = input<CallOutSize | undefined>(undefined);
  protected showCallout: boolean = false;

  ngOnInit(): void {
    this.showCallout = !this.alreadyOptedOut() && !this.isAlreadyStartUpPage();
  }

  protected noThanks(): void {
    this.localStorageService.setItem(DashboardAsStartPageCalloutComponent.LTI_DASHBOARD_AS_START_PAGE_CALLOUT, false);
    this.showCallout = false;

  }

  private alreadyOptedOut(): boolean {
    return this.localStorageService.getItem(DashboardAsStartPageCalloutComponent.LTI_DASHBOARD_AS_START_PAGE_CALLOUT) === 'false';
  }

  private isAlreadyStartUpPage(): boolean {
    return this.initialStateService.getInitialState()?.linkId === 'link_your_goals';
  }

}
